import { FormikProps } from 'formik';
import React from 'react';
import styled from 'styled-components/macro';
import { Alert } from '../../../shared/Alert';
import { PrimaryProgressButton, SecondaryButton } from '../../../shared/Button';
import { Modal, ModalActionButtons, ModalHeader } from '../../../shared/Modal';
import { spacing02 } from '../../../styling/spacing';
import { DesignFormModel } from './designFormModel';

type Props = FormikProps<DesignFormModel> & {
  warnings: Array<string>;
  isOpen: boolean;
  closeModal: () => void;
};

export const DesignFormWarningModal = ({ warnings, isOpen, closeModal, isSubmitting, handleSubmit }: Props) => (
  <Modal isOpen={isOpen}>
    <ModalHeader>Warning</ModalHeader>
    <WarningsContainer>
      {warnings.map((warning, index) => (
        <Alert type="warning" body={warning} key={index} />
      ))}
    </WarningsContainer>
    <ModalActionButtons $align="right">
      <SecondaryButton onClick={closeModal}>Cancel</SecondaryButton>
      <PrimaryProgressButton type="submit" inProgress={isSubmitting} onClick={() => handleSubmit()}>
        {`Ignore ${warnings.length > 1 ? 'warnings' : 'warning'} and save`}
      </PrimaryProgressButton>
    </ModalActionButtons>
  </Modal>
);

const WarningsContainer = styled.div`
  > :not(:last-of-type) {
    margin-bottom: ${spacing02};
  }
`;
